function getMapScript() {
  if (!global.BMap) {
    const ak = '1AhjsRbF26OQwzMlA6vAzMQFTZgemYxx'
    global.BMap = {}
    global.BMap._preloader = new Promise((resolve, reject) => {
      global._initBaiduMap = function () {
        resolve(global.BMap)
        global.document.body.removeChild($script)
        global.BMap._preloader = null
        global._initBaiduMap = null
      }
      const $script = document.createElement('script')
      const $script1 = document.createElement('script')
      const $script2 = document.createElement('script')
      const $link1 = document.createElement('link')
      const $link2 = document.createElement('link')
      global.document.body.appendChild($script)
      setTimeout(function(){
        global.document.body.appendChild($script1)
        global.document.body.appendChild($script2)
        global.document.body.appendChild($link1)
        global.document.body.appendChild($link2)
      },500);
    
   
      $script.src = `https://api.map.baidu.com/api?v=2.0&ak=${ak}&callback=_initBaiduMap`
      $script1.src = `http://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js`
      $script2.src = `http://api.map.baidu.com/library/SearchInfoWindow/1.4/src/SearchInfoWindow_min.js`
      $link1.rel="stylesheet";
      $link1.href="http://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.css";
      $link2.rel="stylesheet";
      $link2.href="http://api.map.baidu.com/library/SearchInfoWindow/1.4/src/SearchInfoWindow_min.css";
    

    })
    return global.BMap._preloader
  } else if (!global.BMap._preloader) {   //如果该值等于null  则BMap实例存在
    return Promise.resolve(global.BMap)    //语法糖  等于Promise.then((res)=>{resolve(global.BMap)})
  } else {
    return global.BMap._preloader
  }

}

export default {
  getMapScript
}



// WEBPACK FOOTER //
// ./src/baiduMap/map.js